import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css'; // or use inline/Tailwind

const Home = () => {
  // Set SEO title
  React.useEffect(() => {
    document.title = "Any Time Movers AU | Professional Adelaide Removalists | 24/7 Moving Services";
  }, []);

  return (
    <div className="homepage">

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Professional Adelaide Removalists | Any Time Movers AU</h1>
          <p>Trusted removalist in City of Playford, City of Salisbury, City of Tea Tree Gully & City of Port Adelaide Enfield. Serving Salisbury, Elizabeth, Munno Para, Gawler, Riverlea, Burton, Paralowie & all Adelaide suburbs</p>
          <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '2rem'}}>
            <Link to="/quote" className="btn-primary">Get a Free Quote</Link>
            <a href="tel:0469303269" className="btn-primary" style={{textDecoration: 'none'}}>Call Us Now</a>
          </div>
          <div className="trust-badges">
            <div className="trust-badge">Fully Insured</div>
            <div className="trust-badge">100% Satisfaction</div>
            <div className="trust-badge">Licensed & Bonded</div>
          </div>
        </div>
        <img src="/anytimemovers1.webp" alt="Professional Adelaide removalist team - Any Time Movers AU" className="hero-img"/>
      </section>

      {/* Why Choose Us */}
      <section className="why-us">
        <h2>Why Choose Us?</h2>
        <div className="benefits">
          <div className="benefit-card">
            <img src="fast.png" alt="Fast" className="fast-img" />
            <h3>Fast & Reliable</h3>
            <p>We move on time, every time – no delays, no surprises.</p>
          </div>
          <div className="benefit-card">
            <img src="safety.png" alt="Safe" className="safe-img" />
            <h3>Safe Handling</h3>
            <p>We treat your belongings like our own – fully insured service.</p>
          </div>
          <div className="benefit-card">
            <img src="/affordable.png" alt="Affordable" className="affordable-img" />
            <h3>Transparent Pricing</h3>
            <p>No hidden fees – you pay based on distance and items.</p>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="video-section">
        <div className="video-container">
          <h2>See Us in Action</h2>
          <p>Watch our team deliver professional moving services</p>
          <div className="video-wrapper">
            <video
              controls
              preload="metadata"
              poster="/anytimemovers1.webp"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            >
              <source src="/any_time_movers.mov" type="video/quicktime" />
              <source src="/any_time_movers.mov" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview">
        <h2>What We Offer</h2>
        <div className="services-grid">
          <div className="service-card-preview">
            <div className="service-icon">🏠</div>
            <h3>Local Removals</h3>
            <p>Fast and stress-free moves within your city or suburb.</p>
          </div>
          <div className="service-card-preview">
            <div className="service-icon">🏢</div>
            <h3>Home Removals</h3>
            <p>Professional handling of your household furniture and goods.</p>
          </div>
          <div className="service-card-preview">
            <div className="service-icon">🏭</div>
            <h3>Office & Factory</h3>
            <p>Minimize downtime with efficient commercial relocations.</p>
          </div>
          <div className="service-card-preview">
            <div className="service-icon">♻️</div>
            <h3>Hard Rubbish</h3>
            <p>Eco-friendly disposal of bulky items and unwanted materials.</p>
          </div>
          <div className="service-card-preview">
            <div className="service-icon">🗑️</div>
            <h3>General Waste</h3>
            <p>Eco-friendly disposal of household and commercial waste.</p>
          </div>
          <div className="service-card-preview">
            <div className="service-icon">📦</div>
            <h3>Storage Solutions</h3>
            <p>Secure short- and long-term storage for your belongings.</p>
          </div>
          <div className="service-card-preview">
            <div className="service-icon">📋</div>
            <h3>Pack & Unpack</h3>
            <p>Expert packing services to keep your items safe during transit.</p>
          </div>
        </div>
        <div style={{textAlign: 'center', marginTop: '40px'}}>
          <Link to="/services" className="btn-secondary">Explore All Services</Link>
        </div>
      </section>


      {/* How It Works */}
      <section className="how-it-works">
        <h2>How It Works</h2>
        <div className="steps">
          <div className="step">
            <span>1</span>
            <h3>Get a Quote</h3>
            <p>Use our form to provide details and receive pricing.</p>
          </div>
          <div className="step">
            <span>2</span>
            <h3>We Pack & Move</h3>
            <p>Our professional team packs, lifts, and transports.</p>
          </div>
          <div className="step">
            <span>3</span>
            <h3>You Relax</h3>
            <p>We set up your new space while you take it easy.</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <h2>What Our Customers Say</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <div className="testimonial-rating">★★★★★</div>
            <p className="testimonial-text">"Professional, quick, and super friendly. The best moving experience we've ever had! They handled everything with care and made our move stress-free."</p>
            <div className="testimonial-author">
              <strong>Sarah J.</strong>
              <span>Mawson Lakes</span>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-rating">★★★★★</div>
            <p className="testimonial-text">"Great local business. The team took care of everything from packing to disposal. Highly recommend! Fair pricing and excellent service."</p>
            <div className="testimonial-author">
              <strong>Daniel M.</strong>
              <span>Prospect</span>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-rating">★★★★★</div>
            <p className="testimonial-text">"Outstanding service! They moved our entire office in record time with zero damage. Professional and reliable - exactly what you need."</p>
            <div className="testimonial-author">
              <strong>Michael T.</strong>
              <span>North Adelaide</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <h2>Ready to Move?</h2>
        <p>Let’s get started with your free, no-obligation quote.</p>
        <Link to="/quote" className="btn-primary">Get a Quote</Link>
      </section>

    </div>
  );
};

export default Home;
